import { useCallback } from 'react';
import useHomeContext from 'Context/HomeContext';
import { dispatchEvent } from '../Dispatcher';

export default function useEventTrackingIdentify() {
  const { homeResource } = useHomeContext();
  return useCallback((userId, identifyProperties) => {
    dispatchEvent({
      type: 'identify',
      properties: {
        userId,
        visitorSessionUUID: homeResource.attr('visitorSessionUuid'),
        properties: identifyProperties,
      },
    });
  }, [homeResource]);
}
